module.exports = __webpack_public_path__ + "img/my_ok.37298fe0.png";